<template>
  <tr>
    <td>
      {{ item.id }}
    </td>
    <td>
      {{ item.name }}
    </td>
    <td>
      {{ item.distance }}
    </td>
  </tr>
</template>

<script>
export default {
  props: ['item']
}
</script>